import React from 'react';
import { AlertCircle } from 'lucide-react';
export function ProblemSection() {
  return <section className="w-full bg-gray-50 py-10 px-4 border-y border-gray-200" data-id="element-122">
      <div className="max-w-3xl mx-auto" data-id="element-123">
        <div className="text-center mb-10" data-id="element-124">
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-6" data-id="element-125"></h2>
        </div>

        <div className="text-center space-y-8" data-id="element-126">
          <div className="space-y-6 text-lg md:text-xl text-gray-800 leading-relaxed" data-id="element-127">
            <p className="font-[700] text-[#DEA0C0]" data-id="element-128">
              La realidad es que los niños no aprenden todos de la misma manera
            </p>
            <p data-id="element-129">
              Cuando comprendemos cómo funciona su proceso de aprendizaje,
              podemos acompañarlos de forma mucho más efectiva.
            </p>
            <p className="font-bold text-2xl text-[#DEA0C0]" data-id="element-130">
              No es solo ayudarlo a aprender… es dejar de sentir que se está
              quedando atrás sin saber qué hacer.
            </p>
          </div>
        </div>
      </div>
    </section>;
}